import { render, staticRenderFns } from "./haokaOrder.vue?vue&type=template&id=3b81b4cd&scoped=true&"
import script from "./haokaOrder.vue?vue&type=script&lang=js&"
export * from "./haokaOrder.vue?vue&type=script&lang=js&"
import style0 from "./haokaOrder.vue?vue&type=style&index=0&id=3b81b4cd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b81b4cd",
  null
  
)

export default component.exports